import type { ReactElement } from 'react';
import { SearchInput } from './SearchInput';
import { ENDPOINT_SEARCH_PLACEHOLDER } from './endpointSearch';

/** KIR-5098: the search box above every endpoint drill-down list. */
export function EndpointSearchInput({
  value,
  onChange,
  className = '',
}: {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}): ReactElement {
  return (
    <SearchInput
      value={value}
      onChange={onChange}
      placeholder={ENDPOINT_SEARCH_PLACEHOLDER}
      className={className}
    />
  );
}
